<template>
  <div>
    <b-container fluid class="tw-mb-5 tw-bg-gray-100 tw-border tw-border-blue-200" style="padding-bottom: 10px;">
      <b-row class="tw-mt-2">
        <!-- BEGIN CHART -->
        <b-col md="12" lg="10" :xl="9" class="tw-overflow-x-scroll" ref="clusterEnrollmentChartContainer">
          <bar-chart
            v-if="loaded"
            :chartData="clusterEnrollment.chartdata"
            :options="clusterEnrollment.options"
            :styles="clusterEnrollment.myStyles"
          >
          </bar-chart>
          <span class="text-secondary tw-text-xs text-center" v-if="last_update">Last Updated: {{last_update}}</span>
        </b-col>
        <!-- END CHART -->
        <!-- BEGIN CARDS -->
        <b-col md="12" lg="2" :xl=3>
          <b-container>
            <b-row>
              <b-col lg="12" :xl=10 class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Beginning Subjects Enrolled
                    </h6>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">
                      {{ beginningTotalEnrollment }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12" :xl=10 class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Current Subjects Enrolled
                    </h6>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">
                      {{ currntTotalEnrollment }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <!-- END CARDS -->
      </b-row>
      <b-row>
        <b-col>
          <div class="tw-mt-auto tw-flex tw-justify-end">
            <info-popover>
              <template v-slot:title>
                Current Subjects Enrolled
              </template>
              <p>For each cluster, show how many subjects are enrolled, and which have met the target.</p>
            </info-popover>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import * as _ from "lodash";

import BarChart from "@/components/charts/BarChart.vue";

const enrollmentTarget = 55;
const totalCluster = 34;

export default {
  mixins: [],
  components: {
    BarChart,
  },
  props: {},
  data() {
    return {
      loaded: false,
      last_update: null,
      beginningTotalEnrollment: 0,
      currntTotalEnrollment: 0,
      lostToFollowupPercent: 0,
      clusterReachedEnrollmentTarget: 0,
      clusterEnrollment: {
        chartdata: {
          // make initial chart with empty data
          datasets: [
            {
              label: "Enrollment",
              backgroundColor: "#37B1CA",
              data: Array(totalCluster).fill(0),
            },
            {
              type: "line",
              backgroundColor: "red",
              borderColor: "red",
              fill: false,
              pointRadius: 0,
              borderWidth: 1,
              label: "Enrollment Target: " + enrollmentTarget,
              data: Array(totalCluster).fill(enrollmentTarget),
            },
          ],
          labels: [
            "1 ET",
            "2 ET",
            "3 C",
            "4 C",
            "5 C",
            "6 C",
            "7 C",
            "8 ET",
            "9 C",
            "10 ET",
            "11 ET",
            "12 C",
            "13 ET",
            "14 C",
            "15 ET",
            "16 ET",
            "17 C",
            "18 ET",
            "19 C",
            "20 ET",
            "21 ET",
            "22 C",
            "23 ET",
            "24 C",
            "25 ET",
            "26 ET",
            "27 ET",
            "28 C",
            "29 C",
            "30 C",
            "31 C",
            "32 ET",
            "33 ET",
            "34 C"
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18,
            },
          },
          title: {
            display: true,
            text: "Current Subjects Enrolled",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster: ET = Eave Tube, C = Control",
                },
              },
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Enrollment",
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        myStyles: {
          height: "25vh",
          width: "100vw",
          position: "relative",
        },
      },
    };
  },
  mounted: function() {
    this.get();
  },
  methods: {
    capitalize: function(value){
        return _.capitalize(value);
    },
    get: function() {
      const that = this;

      // share the API with subject retention donut
      const params = {
        used_by: 'subjectEnrolledChart',
      }

      HTTP.get("/eavetubes/metrics/cluster-enrollment-chart/", { params: params })
        .then((response) => {

          // chart data
          that.clusterEnrollment.chartdata.datasets[0].data = response.data.data.map(count => count.count_enrolled);

          // stats
          that.beginningTotalEnrollment = response.data.number_beginning_subject
          that.currntTotalEnrollment = response.data.number_current_subject
          const lostToFollowupPercent = (response.data.number_lost_to_followup) / response.data.number_beginning_subject
          // limit decimal points to 2
          that.lostToFollowupPercent = `${Number.parseFloat(lostToFollowupPercent.toFixed(2))}`

          that.loaded = true;

        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
  },
};
</script>

<style>
</style>
